<script setup>
import { useUserStore } from '@/stores/user';

import useSessionActions from '~/composables/sessions/useSessionActions';

const props = defineProps({
    session: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['close', 'showRemoveFavoritesRemoveSeatModal']);

const { isFavoriteLoading, isFavorite } = useSessionActions(props.session);
const lock = ref(false);
const userStore = useUserStore();

const handleConfirmRemoveFavorite = async () => {
    if (lock.value) return;
    lock.value = true;

    if (isFavorite.value) {
        await userStore.unfavoriteSession(props.session.unique_id);
    }
    emit('showRemoveFavoritesRemoveSeatModal');

    lock.value = false;
};

const closeModal = () => {
    emit('close');
};
</script>

<template>
    <div>
        <h2>Are you sure you want to remove "{{ session.title }}" from My Favorites?</h2>
        <div class="modal-action-buttons">
            <ProjectButtonSecondary type="button" :disabled="isFavoriteLoading" :loading="isFavoriteLoading"
                :filledIn="true" @click="handleConfirmRemoveFavorite">
                Yes, remove from My Favorites
            </ProjectButtonSecondary>
            <ProjectButtonSecondary type="button" :disabled="isFavoriteLoading" :loading="isFavoriteLoading"
                @click="closeModal">
                Cancel
            </ProjectButtonSecondary>
        </div>
    </div>
</template>
